import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const ProductsPage = () => {
  const [activeCategory, setActiveCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'جميع المنتجات', icon: 'ri-apps-line' },
    { id: 'cameras', name: 'أنظمة كاميرات المراقبة', icon: 'ri-camera-line' },
    { id: 'access', name: 'أنظمة التحكم في الدخول والبصمة', icon: 'ri-fingerprint-line' },
    { id: 'gates', name: 'البوابات والأبواب الأمنية', icon: 'ri-door-open-line' },
    { id: 'alarm', name: 'أنظمة إنذار ومكافحة الحريق', icon: 'ri-alarm-warning-line' },
    { id: 'network', name: 'الشبكات والبنية التحتية', icon: 'ri-router-line' },
  ];

  const products = [
    {
      id: 1,
      category: 'cameras',
      name: 'كاميرا مراقبة 4K عالية الدقة',
      description: 'كاميرا مراقبة بدقة 4K مع رؤية ليلية متقدمة تصل إلى 30 متر، مقاومة للماء والغبار، تسجيل مستمر على مدار الساعة.',
      features: ['دقة 4K Ultra HD', 'رؤية ليلية 30م', 'مقاومة للعوامل الجوية', 'تسجيل مستمر'],
      image: 'https://public.readdy.ai/ai/img_res/24fdfaf53018dd7c930b53358b7a49a3.jpg',
      badge: 'الأكثر مبيعاً',
    },
    {
      id: 2,
      category: 'cameras',
      name: 'كاميرا PTZ متحركة 360 درجة',
      description: 'كاميرا متحركة بتحكم كامل PTZ، زاوية رؤية 360 درجة، تكبير بصري 20x، تتبع تلقائي للحركة.',
      features: ['دوران 360 درجة', 'تكبير بصري 20x', 'تتبع تلقائي', 'تحكم عن بعد'],
      image: 'https://readdy.ai/api/search-image?query=professional%20PTZ%20security%20camera%2C%20motorized%20pan-tilt-zoom%20surveillance%20camera%2C%20white%20dome%20camera%20with%20sleek%20design%2C%20high-tech%20rotating%20CCTV%20camera%2C%20premium%20security%20equipment%2C%20product%20photography%20on%20clean%20background%2C%20commercial%20grade%20surveillance%20device&width=600&height=700&seq=product-ptz-camera-005&orientation=portrait',
      badge: '',
    },
    {
      id: 3,
      category: 'cameras',
      name: 'كاميرا مراقبة داخلية ذكية',
      description: 'كاميرا داخلية بتقنية الذكاء الاصطناعي، كشف الوجوه والحركة، تنبيهات فورية على الهاتف.',
      features: ['ذكاء اصطناعي', 'كشف الوجوه', 'تنبيهات فورية', 'تطبيق جوال'],
      image: 'https://readdy.ai/api/search-image?query=modern%20indoor%20smart%20security%20camera%2C%20sleek%20white%20dome%20camera%20with%20AI%20technology%2C%20contemporary%20home%20surveillance%20device%2C%20minimalist%20design%2C%20product%20photography%20with%20soft%20lighting%2C%20high-tech%20indoor%20monitoring%20camera%2C%20clean%20aesthetic&width=600&height=700&seq=product-indoor-camera-010&orientation=portrait',
      badge: 'جديد',
    },
    {
      id: 4,
      category: 'access',
      name: 'نظام التعرف على الوجه',
      description: 'نظام متطور للتعرف على الوجه بدقة عالية، سرعة استجابة أقل من ثانية، قاعدة بيانات تصل إلى 50,000 وجه.',
      features: ['تعرف على الوجه', 'استجابة فورية', '50,000 وجه', 'شاشة لمس'],
      image: 'https://readdy.ai/api/search-image?query=modern%20facial%20recognition%20access%20control%20system%2C%20sleek%20touchscreen%20biometric%20device%2C%20professional%20security%20terminal%20with%20face%20scanner%2C%20contemporary%20design%2C%20mounted%20on%20clean%20white%20wall%2C%20high-tech%20access%20control%20panel%2C%20corporate%20security%20equipment%2C%20product%20photography&width=600&height=800&seq=product-face-recognition-002&orientation=portrait',
      badge: 'الأكثر تقدماً',
    },
    {
      id: 5,
      category: 'access',
      name: 'قارئ البصمة الاحترافي',
      description: 'جهاز قراءة بصمة عالي الدقة، مقاوم للتزوير، سعة تخزين 10,000 بصمة، سرعة تعرف 0.5 ثانية.',
      features: ['دقة عالية', 'مقاوم للتزوير', '10,000 بصمة', 'سريع جداً'],
      image: 'https://readdy.ai/api/search-image?query=professional%20fingerprint%20scanner%20biometric%20device%2C%20modern%20access%20control%20terminal%20with%20fingerprint%20reader%2C%20sleek%20black%20design%2C%20high-tech%20security%20equipment%2C%20wall-mounted%20biometric%20system%2C%20product%20photography%20with%20dramatic%20lighting&width=600&height=800&seq=product-fingerprint-011&orientation=portrait',
      badge: '',
    },
    {
      id: 6,
      category: 'access',
      name: 'قارئ البطاقات الذكية RFID',
      description: 'نظام بطاقات RFID متطور، قراءة سريعة ودقيقة، مقاوم للماء، يدعم أنواع متعددة من البطاقات.',
      features: ['تقنية RFID', 'قراءة سريعة', 'مقاوم للماء', 'متعدد البطاقات'],
      image: 'https://readdy.ai/api/search-image?query=modern%20RFID%20card%20reader%2C%20sleek%20access%20control%20keypad%2C%20professional%20smart%20card%20scanner%2C%20contemporary%20security%20terminal%2C%20wall-mounted%20access%20device%2C%20clean%20minimalist%20design%2C%20high-tech%20entry%20system%2C%20product%20photography%20with%20soft%20lighting&width=600&height=800&seq=product-card-reader-006&orientation=portrait',
      badge: '',
    },
    {
      id: 7,
      category: 'gates',
      name: 'بوابة أمنية ذكية أوتوماتيكية',
      description: 'بوابة إلكترونية بتحكم كامل، فتح وإغلاق أوتوماتيكي، نظام أمان متعدد المستويات، متوافقة مع جميع أنظمة التحكم.',
      features: ['تحكم أوتوماتيكي', 'أمان متعدد', 'متوافقة', 'متينة'],
      image: 'https://readdy.ai/api/search-image?query=modern%20automatic%20security%20gate%20barrier%2C%20sleek%20electronic%20access%20control%20barrier%20arm%2C%20professional%20parking%20gate%20system%2C%20contemporary%20design%20with%20LED%20lights%2C%20commercial%20security%20barrier%2C%20clean%20industrial%20look%2C%20high-quality%20security%20equipment%2C%20architectural%20photography%20style&width=600&height=650&seq=product-smart-gate-003&orientation=portrait',
      badge: '',
    },
    {
      id: 8,
      category: 'gates',
      name: 'باب أمني مصفح إلكتروني',
      description: 'باب أمني مصفح بقفل إلكتروني متطور، مقاوم للكسر والحريق، نظام فتح متعدد (بصمة، بطاقة، رمز).',
      features: ['مصفح', 'قفل إلكتروني', 'مقاوم للحريق', 'فتح متعدد'],
      image: 'https://readdy.ai/api/search-image?query=modern%20armored%20security%20door%20with%20electronic%20lock%2C%20professional%20reinforced%20entrance%20door%2C%20contemporary%20design%20with%20biometric%20access%2C%20high-security%20entrance%20system%2C%20sleek%20metallic%20finish%2C%20architectural%20security%20product&width=600&height=750&seq=product-armored-door-012&orientation=portrait',
      badge: '',
    },
    {
      id: 9,
      category: 'gates',
      name: 'بوابة دوارة ثلاثية الأذرع',
      description: 'بوابة دوارة احترافية للتحكم في حركة الدخول والخروج، متينة ومقاومة للعبث، تدعم جميع أنظمة التحكم.',
      features: ['ثلاثية الأذرع', 'متينة جداً', 'مقاومة للعبث', 'تحكم ذكي'],
      image: 'https://readdy.ai/api/search-image?query=professional%20tripod%20turnstile%20gate%2C%20modern%20three-arm%20rotating%20security%20barrier%2C%20stainless%20steel%20access%20control%20turnstile%2C%20contemporary%20entrance%20control%20system%2C%20commercial%20security%20gate%2C%20clean%20industrial%20design&width=600&height=700&seq=product-turnstile-013&orientation=portrait',
      badge: '',
    },
    {
      id: 10,
      category: 'alarm',
      name: 'نظام إنذار الحريق المتكامل',
      description: 'نظام كشف وإنذار حريق متطور، كواشف دخان وحرارة، إنذار صوتي وضوئي، اتصال تلقائي بالدفاع المدني.',
      features: ['كشف مبكر', 'إنذار فوري', 'اتصال تلقائي', 'معتمد'],
      image: 'https://readdy.ai/api/search-image?query=professional%20fire%20alarm%20control%20panel%2C%20modern%20fire%20detection%20system%2C%20red%20emergency%20alert%20device%2C%20high-tech%20fire%20safety%20equipment%2C%20wall-mounted%20alarm%20system%2C%20clean%20corporate%20design%2C%20security%20control%20panel%2C%20product%20photography%20with%20dramatic%20lighting&width=600&height=750&seq=product-fire-alarm-004&orientation=portrait',
      badge: 'معتمد',
    },
    {
      id: 11,
      category: 'alarm',
      name: 'نظام إنذار ضد السرقة',
      description: 'نظام إنذار متطور ضد السرقة والتسلل، حساسات حركة وفتح الأبواب، تنبيهات فورية على الجوال.',
      features: ['حساسات ذكية', 'تنبيهات فورية', 'تطبيق جوال', 'سهل التركيب'],
      image: 'https://readdy.ai/api/search-image?query=modern%20burglar%20alarm%20system%20control%20panel%2C%20professional%20intrusion%20detection%20device%2C%20sleek%20security%20alarm%20keypad%2C%20contemporary%20home%20security%20system%2C%20white%20clean%20design%2C%20high-tech%20alarm%20control%20unit&width=600&height=700&seq=product-burglar-alarm-014&orientation=portrait',
      badge: '',
    },
    {
      id: 12,
      category: 'alarm',
      name: 'كاشف دخان ذكي لاسلكي',
      description: 'كاشف دخان ذكي بتقنية لاسلكية، بطارية تدوم 10 سنوات، إنذار صوتي قوي، اتصال بالتطبيق.',
      features: ['لاسلكي', 'بطارية 10 سنوات', 'إنذار قوي', 'تطبيق ذكي'],
      image: 'https://readdy.ai/api/search-image?query=modern%20wireless%20smoke%20detector%2C%20sleek%20white%20circular%20fire%20alarm%20sensor%2C%20contemporary%20smart%20home%20safety%20device%2C%20ceiling-mounted%20smoke%20alarm%2C%20minimalist%20design%2C%20product%20photography%20with%20clean%20background&width=600&height=600&seq=product-smoke-detector-015&orientation=squarish',
      badge: 'جديد',
    },
    {
      id: 13,
      category: 'network',
      name: 'سويتش شبكات احترافي PoE',
      description: 'سويتش شبكات بتقنية PoE لتغذية الكاميرات، 24 منفذ جيجابت، إدارة ذكية، أداء عالي.',
      features: ['24 منفذ PoE', 'جيجابت', 'إدارة ذكية', 'أداء عالي'],
      image: 'https://readdy.ai/api/search-image?query=professional%20PoE%20network%20switch%2C%20modern%2024-port%20gigabit%20ethernet%20switch%2C%20black%20rack-mounted%20networking%20equipment%2C%20enterprise-grade%20network%20hardware%2C%20LED%20indicators%2C%20clean%20product%20photography&width=600&height=500&seq=product-poe-switch-016&orientation=landscape',
      badge: '',
    },
    {
      id: 14,
      category: 'network',
      name: 'جهاز تسجيل شبكي NVR',
      description: 'جهاز تسجيل شبكي عالي الأداء، يدعم حتى 32 كاميرا، تخزين ضخم، عرض وتسجيل بدقة 4K.',
      features: ['32 كاميرا', 'تخزين ضخم', 'دقة 4K', 'بحث ذكي'],
      image: 'https://readdy.ai/api/search-image?query=professional%20network%20video%20recorder%20NVR%2C%20modern%20black%20security%20recording%20device%2C%20enterprise-grade%20surveillance%20storage%20system%2C%20rack-mounted%20NVR%20unit%2C%20LED%20display%20panel%2C%20high-tech%20security%20equipment&width=600&height=500&seq=product-nvr-017&orientation=landscape',
      badge: '',
    },
    {
      id: 15,
      category: 'network',
      name: 'كابلات شبكات Cat6 احترافية',
      description: 'كابلات شبكات Cat6 عالية الجودة، سرعة نقل تصل إلى 10 جيجابت، مقاومة للتداخل، معتمدة.',
      features: ['Cat6', '10 جيجابت', 'مقاومة للتداخل', 'معتمدة'],
      image: 'https://readdy.ai/api/search-image?query=professional%20Cat6%20network%20cables%20bundle%2C%20high-quality%20ethernet%20cables%20in%20various%20colors%2C%20organized%20networking%20cables%2C%20commercial-grade%20network%20infrastructure%2C%20clean%20product%20photography%20on%20white%20background&width=600&height=600&seq=product-cat6-cables-018&orientation=squarish',
      badge: '',
    },
  ];

  const filteredProducts = activeCategory === 'all' 
    ? products 
    : products.filter(product => product.category === activeCategory);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative h-[350px] flex items-center justify-center overflow-hidden mt-20">
        <div className="absolute inset-0 z-0">
          <img
            src="https://readdy.ai/api/search-image?query=modern%20security%20products%20display%20showcase%2C%20professional%20security%20equipment%20exhibition%2C%20high-tech%20surveillance%20devices%20arranged%20professionally%2C%20contemporary%20security%20technology%20showroom%2C%20clean%20corporate%20environment%2C%20professional%20product%20photography&width=1920&height=700&seq=products-hero-bg-001&orientation=landscape"
            alt="منتجاتنا"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-navy/85 via-navy/75 to-navy/85"></div>
        </div>

        <div className="container mx-auto px-6 relative z-10 text-center">
          <div className="flex items-center justify-center gap-2 text-white/80 text-sm mb-6">
            <Link to="/" className="hover:text-primary transition-all-300">
              الرئيسية
            </Link>
            <i className="ri-arrow-left-s-line"></i>
            <span className="text-primary">المنتجات</span>
          </div>

          <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6">
            منتجاتنا <span className="text-primary">الأمنية</span>
          </h1>
          <p className="text-xl text-white/90 max-w-2xl mx-auto">
            أحدث الأنظمة والمعدات الأمنية من أفضل الشركات العالمية
          </p>
        </div>
      </section>

      {/* Products Section */}
      <section className="py-24" data-product-shop>
        <div className="container mx-auto px-6">
          {/* Categories */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setActiveCategory(category.id)}
                className={`group p-6 rounded-2xl border-2 transition-all-300 text-right cursor-pointer ${
                  activeCategory === category.id
                    ? 'border-primary bg-primary text-white shadow-xl'
                    : 'border-gray-medium/20 bg-white hover:border-primary hover:shadow-lg'
                }`}
              >
                <div className="flex items-center gap-4">
                  <div className={`w-14 h-14 flex items-center justify-center rounded-xl transition-all-300 ${
                    activeCategory === category.id
                      ? 'bg-white/20'
                      : 'bg-primary/10 group-hover:bg-primary/20'
                  }`}>
                    <i className={`${category.icon} text-2xl ${
                      activeCategory === category.id ? 'text-white' : 'text-primary'
                    }`}></i>
                  </div>
                  <span className={`text-lg font-semibold ${
                    activeCategory === category.id ? 'text-white' : 'text-navy-light'
                  }`}>
                    {category.name}
                  </span>
                </div>
              </button>
            ))}
          </div>

          {/* Products Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredProducts.map((product) => (
              <div
                key={product.id}
                className="group bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all-300 border border-gray-medium/10"
              >
                {/* Image */}
                <div className="relative h-[300px] overflow-hidden bg-gray-light/20">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-all-300"
                  />
                  {product.badge && (
                    <div className="absolute top-4 right-4 px-4 py-2 bg-primary text-white text-xs font-semibold rounded-full shadow-lg">
                      {product.badge}
                    </div>
                  )}
                </div>

                {/* Content */}
                <div className="p-6">
                  <h3 className="text-xl font-bold text-navy-light mb-3 group-hover:text-primary transition-all-300">
                    {product.name}
                  </h3>
                  <p className="text-gray-dark text-sm leading-relaxed mb-4">
                    {product.description}
                  </p>

                  {/* Features */}
                  <div className="flex flex-wrap gap-2 mb-6">
                    {product.features.map((feature, index) => (
                      <span
                        key={index}
                        className="px-3 py-1 bg-gray-light/50 text-gray-dark text-xs rounded-full"
                      >
                        {feature}
                      </span>
                    ))}
                  </div>

                  {/* Button */}
                  <Link
                    to="/contact"
                    className="w-full block text-center px-6 py-3 border-2 border-primary text-primary font-semibold rounded-lg hover:bg-primary hover:text-white transition-all-300 whitespace-nowrap"
                  >
                    اطلب عرض سعر
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ProductsPage;